<template>
    <scroll-wrap>
        <div class="main-box">
            <div class="content-wrap">
                <div class="country">
                    <img :src="require(`./../../assets/image/${$store.state.record.country}.png`)" alt="">
                </div>
                <div class="main-area">
                    <div class="main-area-box">
                        <div class="store-item">
                            <div class="left-wrap">
                                <div class="tit">
                                <span class="zh">
                                    <span style="color: red">A仓 </span>运费计算
                                </span>
                                    <span class="en">
                                    FREIGHT CALCULATION
                                </span>
                                </div>
                                <div class="cont">
                                    <div class="input-wrap">
                                        <span class="danwei">￥</span>
                                        <input type="number" v-model="AremoteData.deliveryFee">
                                        <span class="btn">
                                        <span>查看物流报价表</span>
                                        <el-image
                                                style="width: 64px; height: 58px"
                                                :src="url"
                                                :preview-src-list="srcList">
                                        </el-image>
                                    </span>
                                    </div>
                                    <div class="info">
                                        *请填写运费(如有小数，则小数点保留两位)
                                    </div>
                                </div>
                            </div>
                            <div class="line"></div>
                            <div class="rigth-wrap">
                                <div class="tit">
                                <span class="zh">
                                    <span style="color: red">A仓 </span>物流选择
                                </span>
                                    <span class="en">
                                    LOGISTICS OPTIONS
                                </span>
                                </div>
                                <div class="cont">
                                    <div class="item" :class="{active:AremoteData.deliveryType === 'DHL'}"  @click="AremoteData.deliveryType = 'DHL'">
                                        <img src="./../../assets/image/logisticsDelivery/dhl.png" alt="">
                                        <i class="iconfont icon-xuanze-danxuan"></i>
                                    </div>
                                    <div class="item" :class="{active:AremoteData.deliveryType === 'EMS'}" @click="AremoteData.deliveryType = 'EMS'">
                                        <img src="./../../assets/image/logisticsDelivery/e.png" alt="">
                                        <i class="iconfont icon-xuanze-danxuan"></i>
                                    </div>
                                    <div class="item" :class="{active:AremoteData.deliveryType === 'OTHER'}" @click="AremoteData.deliveryType = 'OTHER'">
                                        <img src="./../../assets/image/logisticsDelivery/san.png" alt="">
                                        <i class="iconfont icon-xuanze-danxuan"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="store-item">
                            <div class="left-wrap">
                                <div class="tit">
                                <span class="zh">
                                    <span style="color: red">B仓 </span>运费计算
                                </span>
                                    <span class="en">
                                    FREIGHT CALCULATION
                                </span>
                                </div>
                                <div class="cont">
                                    <div class="input-wrap">
                                        <span class="danwei">￥</span>
                                        <input type="number" v-model="BremoteData.deliveryFee">
                                        <span class="btn">
                                        <span>查看物流报价表</span>
                                        <el-image
                                                style="width: 64px; height: 58px"
                                                :src="url"
                                                :preview-src-list="srcList">
                                        </el-image>
                                    </span>
                                    </div>
                                    <div class="info">
                                        *请填写运费(如有小数，则小数点保留两位)
                                    </div>
                                </div>
                            </div>
                            <div class="line"></div>
                            <div class="rigth-wrap">
                                <div class="tit">
                                <span class="zh">
                                    <span style="color: red">B仓 </span>物流选择
                                </span>
                                    <span class="en">
                                    LOGISTICS OPTIONS
                                </span>
                                </div>
                                <div class="cont">
                                    <div class="item" :class="{active:BremoteData.deliveryType === 'DHL'}"  @click="BremoteData.deliveryType = 'DHL'">
                                        <img src="./../../assets/image/logisticsDelivery/dhl.png" alt="">
                                        <i class="iconfont icon-xuanze-danxuan"></i>
                                    </div>
                                    <div class="item" :class="{active:BremoteData.deliveryType === 'EMS'}" @click="BremoteData.deliveryType = 'EMS'">
                                        <img src="./../../assets/image/logisticsDelivery/e.png" alt="">
                                        <i class="iconfont icon-xuanze-danxuan"></i>
                                    </div>
                                    <div class="item" :class="{active:BremoteData.deliveryType === 'OTHER'}" @click="BremoteData.deliveryType = 'OTHER'">
                                        <img src="./../../assets/image/logisticsDelivery/san.png" alt="">
                                        <i class="iconfont icon-xuanze-danxuan"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="foot">
                <span class="btn" v-if="$route.meta.next" @click="remote">
                    确认物流
                </span>
            </div>
        </div>
    </scroll-wrap>
</template>

<script>
    export default {
        name: "investigate",
        data() {
            return {
                url: require('./../../assets/image/logisticsDelivery/quotation.jpg'),
                srcList: [
                    require('./../../assets/image/logisticsDelivery/quotation.jpg'),
                ],
                next:false,
                AremoteData:{
                    id:'',
                    deliveryFee:'',
                    deliveryType:'',
                    deliveryCode:''
                },
                BremoteData:{
                    id:'',
                    deliveryFee:'',
                    deliveryType:'',
                    deliveryCode:''
                },
                question:{
                    questionIndex:7,
                    score:10,
                    isFirst:true
                }
            }
        },
        created(){
            let storeList = JSON.parse(JSON.stringify(this.$store.state.record.store));
            this.AremoteData.id = storeList['A仓'].id;
            this.AremoteData.deliveryCode = parseInt(Math.random()*(999999999999-100000000000)+100000000000);
            this.BremoteData.id = storeList['B仓'].id;
            this.BremoteData.deliveryCode = parseInt(Math.random()*(999999999999-100000000000)+100000000000);
        },
        methods:{
            remote(){
                if(this.AremoteData.deliveryFee === ''){
                    this.$swal({
                        text:'请填写计算后的A仓运费',
                        icon:'error'
                    })
                    return false
                }
                if(this.AremoteData.deliveryType === ''){
                    this.$swal({
                        text:'请选择A仓的运输方式',
                        icon:'error'
                    })
                    return false
                }
                if(this.BremoteData.deliveryFee === ''){
                    this.$swal({
                        text:'请填写计算后的B仓运费',
                        icon:'error'
                    })
                    return false
                }
                if(this.BremoteData.deliveryType === ''){
                    this.$swal({
                        text:'请选择B仓的运输方式',
                        icon:'error'
                    })
                    return false
                }
                let money = this.$store.state.record.country === 'MY' ? 388.13 :7500;
                let originScore = JSON.parse(JSON.stringify(this.$store.state.score))
                let txt = this.$store.state.record.country === 'MY'
                    ? "答案：运费388.13元，最佳运输方式：第三方货代。说明：假设一条头巾50克，不考虑包装重量，每个仓库是5000条，每个仓库头巾的总重量是250KG，按照DHL运价表，运往马来西亚的每公斤运费为38.5；按照EUB报价，每公斤40元运费，但限重2KG。货代报价具有价格上的显著优势，且海运到马来西亚时间短，符合海外仓的集散功能，因此选择货代。每个仓库的货物总体积为0.25*0.45*0.03*5000=16.875立方米（运费吨），大于0.25吨。因为货物的重量和体积都不足一个集装箱，所以采用拼箱，运费为：23*16.875=388.125≈388.13元"
                    : "答案：运费7500元，最佳运输方式：第三方货代。说明：假设一件羽绒服总量是100g,每个仓库3000件，每个仓库羽绒服总重量是300公斤，按照DHL运价表，运往俄罗斯每公斤运价为94.15；按照EUB规定，运往俄罗斯每公斤运价为55元，且限重2KG。因此货代的报价具有价格优势，25元，且全程14天，从海外仓的集散功能看，可以选择货代，物流费用为25*300=7500元"

                if(this.AremoteData.deliveryFee !=='' && this.AremoteData.deliveryType !=='' && this.BremoteData.deliveryFee !=='' && this.BremoteData.deliveryType !==''){

                        if(this.AremoteData.deliveryFee == money && this.AremoteData.deliveryType =='OTHER' && this.BremoteData.deliveryFee ==money && this.BremoteData.deliveryType =='OTHER'){

                            if(this.$store.state.score[this.question.questionIndex]===undefined ){
                                originScore[this.question.questionIndex] = this.question.score
                                this.$store.commit('setState',{dataKey: 'score', value: originScore})

                            }

                            this.$swal({
                                html:`<div style="color: green;font-size: 20px;font-weight: bolder;margin-bottom: 10px">回答正确。</div><div style="text-align: left">${txt}</div>`,
                                icon:'success',
                                confirmButtonText: '开始物流交运'
                            }).then(()=>{
                                let Aremote = new Promise(resolve => {
                                    this.axios.post('/student/store/exp/in/delivery',this.AremoteData).then(res=>{
                                        resolve(res)
                                    })
                                })
                                let Bremote = new Promise(resolve => {
                                    this.axios.post('/student/store/exp/in/delivery',this.BremoteData).then(res=>{
                                        resolve(res)
                                    })
                                })
                                Promise.all([Aremote,Bremote]).then(res=>{
                                    for(let i=0;i<res.length;i++){
                                        if(!res[i].succeed){
                                            return false
                                        }
                                    }
                                    this.$swal({
                                        text:'物流交运成功',
                                        icon:'success',
                                        confirmButtonText: '下一步'
                                    }).then(res=>{
                                        this.$router.push(this.$route.meta.next)
                                    });
                                })
                            })

                        }else {
                            this.$swal({
                                html:`<div style="color: red;font-size: 20px;font-weight: bolder;margin-bottom: 10px">回答错误。</div><div style="text-align: left">${txt}</div>`,
                                icon:'error'
                            })
                            if(this.$store.state.score[this.question.questionIndex]===undefined ){
                                originScore[this.question.questionIndex] = 0
                                this.$store.commit('setState',{dataKey: 'score', value: originScore})
                                this.question.isFirst = false;
                            }
                        }

                }
            }
        }
    }
</script>

<style scoped lang="scss">
    .main-box {
        height: 100%;

        .content-wrap {
            display: flex;
            position: relative;
            min-height: calc(100% - 88px);
            justify-content: flex-start;
            flex-grow: 1;

            .country {
                position: relative;
                width: 364px;min-width:364px;

                img {
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                }
            }

            .main-area {
                flex-grow: 1;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                padding: 20px;

                h6 {
                    width: 100%;
                    text-align: left;
                    padding-left: 60px;
                    line-height: 60px;
                    font-size: 16px;

                    i {
                        color: red;
                        margin-right: 3px;
                    }

                    e {
                        color: #004BFF;
                    }
                }

                > div.title {
                    font-size: 20px;
                    font-weight: bolder;
                    color: #000000;
                    text-align: left;
                    margin-bottom: 20px;
                }

                .main-area-box {
                    display: flex;
                    flex-direction: column;
                    justify-content: center;

                    .store-item {
                        display: flex;
                        margin-bottom: 20px;
                        .left-wrap {
                            display: flex;
                            flex-direction: column;
                            align-items: flex-start;

                            div.tit {
                                margin-bottom: 10px;
                                display: flex;
                                flex-direction: column;
                                align-items: flex-start;

                                span.zh {
                                    font-size: 22px;
                                    font-weight: bolder;
                                }

                                span.en {
                                    font-size: 12px;
                                }
                            }

                            div.cont {
                                div.input-wrap {
                                    display: flex;
                                    position: relative;
                                    span.danwei {
                                        position: absolute;
                                        left: 4px;
                                        top: 4px;
                                        display: flex;
                                        font-size: 20px;
                                        font-weight: bolder;
                                    }

                                    > input {
                                        width: 188px;
                                        height: 64px;
                                        line-height: 64px;
                                        border: 1px solid #2c3e50;
                                        border-radius: 10px;
                                        outline: none;
                                        padding: 0 10px 0 30px;
                                        font-size: 22px;
                                    }

                                    span.btn {
                                        margin-left: 20px;
                                        height: 64px;
                                        display: flex;
                                        align-items: center;
                                        justify-content: center;
                                        border-radius: 12px;
                                        color: #FFFFFF;
                                        background: #004BFF;
                                        padding: 0 20px;
                                        font-size: 16px;
                                        > span {
                                            margin-right: 6px;
                                        }
                                        i {
                                            display: block;
                                            margin-left: 10px;
                                            font-size: 30px;
                                        }
                                    }
                                }

                                div.info {
                                    margin-top: 10px;
                                    font-size: 16px;
                                    text-align: left;
                                }
                            }
                        }

                        .line {
                            height: 100%;
                            border-left: 1px dashed #000;
                            margin: 0 40px;
                        }

                        .rigth-wrap {
                            display: flex;
                            flex-direction: column;
                            align-items: flex-start;

                            div.tit {
                                margin-bottom: 10px;
                                display: flex;
                                flex-direction: column;
                                align-items: flex-start;

                                span.zh {
                                    font-size: 22px;
                                    font-weight: bolder;
                                }

                                span.en {
                                    font-size: 12px;
                                }
                            }

                            div.cont {
                                display: flex;

                                .item {
                                    height: 64px;
                                    margin-right: 20px;
                                    cursor: pointer;
                                    &.active {
                                        i {
                                            color: #FBB521;
                                        }
                                    }
                                    > img {
                                        width: 188px;
                                        height: 64px;
                                        margin-bottom: 12px;
                                    }
                                    > i {
                                        font-size: 26px;
                                        color: #9e9e9e;
                                    }
                                }

                            }
                        }
                    }
                }
            }
        }

        > .foot {
            background: #EEEFEF;
            display: flex;
            align-items: center;
            justify-content: center;border-radius:0 0 10px 10px;
            height: 88px;
            border-bottom-left-radius: 10px;
            border-bottom-right-radius: 10px;

            span.btn {
                cursor: pointer;
                padding: 10px 38px;
                background: #004BFF;
                color: #FFFFFF;
                border-radius: 100px;
                margin-right: 40px;

                &:hover {
                    opacity: 0.8;
                }

                &:last-child {
                    margin-right: 0;
                }
            }
        }
    }
</style>
